module.exports = __webpack_public_path__ + "media/images/lig/logo-life-is-good-abf6ee33d27d4c10f906b738f8466be4.svg";